import { defineStore } from 'pinia'
import { ref } from 'vue';
import type { Ref } from 'vue';
import type { ThemeCategory } from '@/resources/types';
import { useNuxtApp } from '#imports';

export const useThemeCategoryStore = defineStore('themeCategory', () => {
  const { $logger } = useNuxtApp();
  const themeCategoriesLoading: Ref<boolean> = ref(false);
  const themeCategories: Ref<ThemeCategory[]> = ref([]);

  async function fetchThemeCategories() {
    themeCategoriesLoading.value = true;
    try {
      themeCategories.value = await $fetch('/api/tyk/theme-categories');
    } catch (error) {
      $logger.error(error);
    } finally {
      themeCategoriesLoading.value = false;
    }
  }

  return {
    themeCategories,
    themeCategoriesLoading,
    fetchThemeCategories
  }
})